// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"2":"112b065b","490":"8f1f0996"}[chunkId] + ".js";
};